export interface PlanDetailRowData {
  key: string;
  label: string;
  value: string;
  indicator?: string;
}
export const UNLIMITED_KEY = 'UNLIMITED';
